module.exports = __webpack_public_path__ + "static/media/advanceTwoColAd.04638cb2.png";